
export const ContentTypes = {
  SingleMedia: 'SingleMedia',
  Playlist: 'Playlist',
  MainWithBackups: 'MainWithBackups',
  BalancedFallbacks: 'BalancedFallbacks',
  MultiChannel: 'MultiChannel',
};

const Content = {

  currentPlayer: null,

  onPlayer: player => {
    Content.currentPlayer = player;
  },

  processConfiguration: (loadedConfiguration = {}, processMedia = () => null) => {
    const contentType = loadedConfiguration.contentMediasType || (loadedConfiguration.playlist ? ContentTypes.Playlist : ContentTypes.SingleMedia);
    const contentMedias = loadedConfiguration.contentMedias;
    let singleMedia, single_media_id, playlist, playlist_media_ids, mainWithBackups, balancedFallbacks, multiChannel, errorMedia;

    switch( contentType) {
      case ContentTypes.SingleMedia:
        // const media = contentMedias.length > 0 ? contentMedias[0] : loadedConfiguration.media;    // REVIEW comporbar comportamiento de cms al respecto // TOFIX se rompe (ejemplo: https://cms.codev8.net/cms-player/120eb32d-0d54-409f-9141-322bd98a71a5)
        // singleMedia = processMedia( loadedConfiguration, media);
        // single_media_id = media.id;
        singleMedia = processMedia( loadedConfiguration, loadedConfiguration.media);
        single_media_id = loadedConfiguration.media.id;
        break;
      case ContentTypes.Playlist:
        const sorted_medias_list = loadedConfiguration.playlist.medias.sort( (element1,element2) => element1.order - element2.order);
        playlist = sorted_medias_list.map( element => processMedia( loadedConfiguration, element.media));
        playlist_media_ids = sorted_medias_list.map( element => element.media.id);
        break;
      case ContentTypes.MainWithBackups:
        mainWithBackups = {
          current: 0,
          contents: contentMedias.map( element => processMedia( loadedConfiguration, element.media)),
          media_ids: contentMedias.map( element => element.media.id),
        };
        break;
      case ContentTypes.BalancedFallbacks:
        balancedFallbacks = {
          current: 0,
          contents: contentMedias.map( element => processMedia( loadedConfiguration, element.media)),
          media_ids: contentMedias.map( element => element.media.id),
        };
        break;
      case ContentTypes.MultiChannel:
        const multiChannelIconFile = loadedConfiguration.contentMediasMultiChannelIconFile;
        multiChannel = {
          current: 0,
          mainIconUrl: (multiChannelIconFile && multiChannelIconFile.url) || null,
          contents: contentMedias.map( element => processMedia( loadedConfiguration, element.media)),
          iconUrls: contentMedias.map( element => (element.iconFile && element.iconFile.url) || null),
          media_ids: contentMedias.map( element => element.media.id),
        };
        break;
      default:;
    }

    if( loadedConfiguration.errorMedia) errorMedia = processMedia( loadedConfiguration, loadedConfiguration.errorMedia);

    return { contentType, singleMedia, single_media_id, playlist, playlist_media_ids, mainWithBackups, balancedFallbacks, multiChannel, errorMedia };
  },

  changeMultiChannel: (multiChannel, i, specificContentHandler) => {
    const { contents } = multiChannel;

    multiChannel.current = i;
    if( specificContentHandler?.changeMultiChannel ) specificContentHandler.changeMultiChannel( Content.currentPlayer, contents[ multiChannel.current ] );
  },

  // TODO active behaviour MainWithBackups, BalancedFallbacks

  getCurrentMediaInfo: (contentData, current_playlist_index = 0) => {
    const { contentType, single_media_id, playlist_media_ids, mainWithBackups, balancedFallbacks, multiChannel } = contentData;
    let media_id;

    switch( contentType) {
      case ContentTypes.SingleMedia: {
        media_id = single_media_id;
        break;
      } case ContentTypes.Playlist: {
        media_id = playlist_media_ids[ current_playlist_index ];
        break;
      } case ContentTypes.MainWithBackups: {
        const { current, media_ids } = mainWithBackups;
        media_id = media_ids[ current ];
        break;
      } case ContentTypes.balancedFallbacks: {
        const { current, media_ids } = balancedFallbacks;
        media_id = media_ids[ current ];
        break;
      } case ContentTypes.multiChannel: {
        const { current, media_ids } = multiChannel;
        media_id = media_ids[ current ];
        break;
      } default:;
    }

    return { id: media_id };
  },

};

export default Content;

